export enum FollowUpStatus {    
    PendingSurvey = 0,
    PendingLabChoice = 5,

    QuestPendingAddress = 100,
    QuestPendingLabOrder = 105,
    QuestPendingResults = 110,
    QuestDoneNoResults = 199,

    PhlebotPendingRequisition = 200,
    PhlebotPendingInitiation = 205,
    PhlebotPendingCompletion = 210,
    PhlebotDoneNoResults = 299,

    DirectPendingAppointment = 300,
    DirectPendingResults = 305,

    Complete = 1000,
    CompleteQuest = 1001,
    CompletePhlebot = 1002,
    CompleteDirectToCenter = 1003,

    Incomplete = 2000
}